<template><!-- svgo-optimised -->
<svg class="icon icon__pause" viewBox="0 0 15 15" xmlns="http://www.w3.org/2000/svg"><path d="M4.5 4.5h2v6h-2zM8.5 4.5h2v6h-2z" fill="#121212"/></svg></template>